import * as firebase from "firebase";
import React, {Component} from "react";
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import logo from '../img/logo_black.jpg'
import { Button, Divider, Form, Grid, Header, Icon, Image, Message, Segment } from "semantic-ui-react";

export class  LoginPageTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      password: "",
      user: null,
      loadingForget:false,
      loadingLogin:false,
      loading: true

    };

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        this.setState({ 'user':  firebase.auth().currentUser });
        this.setState({ 'loading': false });
      } else {
        // No user is signed in.
        if(this){
          this.setState({ 'user': null });
          this.setState({ 'loading': false });
        }

      }
    }).bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.emailLogin = this.emailLogin.bind(this);
  }

  handleEmailChange = e => {
    this.setState({ 'emailAddress': e.target.value });
  };

  handlePasswordChange = e => {
    this.setState({ 'password': e.target.value });
  };

  facebookLogin = async () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    return firebase.auth().signInWithRedirect(provider).then(function() {
      if(typeof window !== 'undefined'){
        window.location.replace('/')
      }
    })
  };

  emailLogin = async () => {
    firebase.auth().signInWithEmailAndPassword(this.state.emailAddress, this.state.password)
    .catch(function(error) {
      console.error(`Could not sign in: ${error.message}`);
    }).then(function() {
      if(firebase.auth().currentUser){
        if(typeof window !== 'undefined'){
          window.location.replace('/')
        }
      }
      else{
        alert("We were unable to log you in, please verify that your email address and password are correct.");
      }
    });
  };

  forgotPassword = async () => {
    this.setState({ 'loadingForget': true });

    if(!this.state.emailAddress){
      this.setState({ 'loadingForget': false });

      alert("Please enter your \"Email Address\" in the email box  below.");
      return;

    }
    firebase.auth().sendPasswordResetEmail(this.state.emailAddress)
    .catch(function(error) {
      console.error(error);
      console.error(`Could not sign in: ${error.message}`);
      alert("Please make sure you entered a valid email address.");
    });
    this.setState({ 'loadingForget': true });
  };

  render() {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            height: '100%',
            lineHeight: '1',
            justifyContent: 'space-around',
            alignItems: 'left',
            flexDirection: 'column',
          }}
        >
        </div>
        <div className="content has-text-centered">
          <Grid textAlign='center' verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as='h2' color='dark blue' textAlign='center'>
                <Image src={logo} style={{ width: '5em', height: '5em' }}/> Login to your account
              </Header>
              <Form size='large'>
                <Segment stacked>
                  <Form.Field>
                    <input placeholder='Email Address' id={"emailAddress"} onInput={this.handleEmailChange}/>
                  </Form.Field>
                  <Form.Field>
                    <input placeholder='Password' id={"password"} type={"password"} onInput={this.handlePasswordChange}/>
                  </Form.Field>
                  <Button color='dark blue' fluid size='large' onClick={this.emailLogin} loading={this.state.loadingLogin}>
                    Login
                  </Button>
                  <Divider horizontal>Or</Divider>

                  <Button color='facebook' fluid size='large' onClick={this.facebookLogin}>
                    <Icon name='facebook'/>
                    Login With Facebook
                  </Button>
                  <Divider horizontal>need help? </Divider>
                  <Button.Group>
                    <Button onClick={this.forgotPassword} loading={this.state.loadingForget}>Forgot Password</Button>
                    <Button.Or />
                    <Button positive as={Link} to="/signup" >Sign Up Instead</Button>
                  </Button.Group>
                  <Message>
                    Lets have a GOOD TIME
                  </Message>
                </Segment>
              </Form>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

LoginPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const LoginPage = () => {
  return (
      <LoginPageTemplate />
  )
}

LoginPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default LoginPage;
